/* eslint-disable no-console */
import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import Axios from "axios";
import VuexPersist from "vuex-persist";
import Misc from "./storeMisc";
import router from "./router";
import PotatoStore from "./store/PotatoStore";
import OnionStore from "./store/OnionStore";
import GeneralInfoStore from "./store/GeneralInfoStore";
import VisualAnalysisStore from "./store/VisualAnalysisStore";
import baseUrl from "./baseurl";
import { reject } from "lodash";

Vue.use(Vuex);

const _ = require("lodash");
const vuexLocalStorage = new VuexPersist({
  key: "vuex", // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
});

export default new Vuex.Store({
  plugins: [vuexLocalStorage.plugin],
  state: {
    editGroupId: "",
    baseUrl: baseUrl,
    prevRoute: "",
    loginError: false,
    loading: false,
    nonEditflag: false,
    savedTabs: 0,
    activeTab: 1,
    status: "",
    snackbar: false,
    snackbarMsg: "Error Occured",
    selectedCommodity: "",
    docId: "",
    token: window.localStorage.getItem("token") || "",
    //User Creds
    user: "",
    username: "",
    firstName: "",
    lastName: "",
    //  User Creds end
    cmdgroup: {},
    modalVisible: false,
    availableUsers: [],
    activeUser: {},
    aclGroups: [], //@P:the list of roles and permissions
    template: false,
    sampleInfo: false,
    report: false,
    editSample: false, //@P: CHECKS WEATHER THE INSPECTION RETURNED FROM SUMMARY
    commGroups: [],
    activeGroup: {},
    Commodities: [],
    reportComments: [],
    generalInfo: {
      purchase_order: {
        value: "",
        flag: 1,
      },
      item_no: {
        value: "",
        flag: 1,
      },
      vendor_no: {
        value: "",
        flag: 1,
      },
      item_description: {
        value: "",
        flag: 1,
      },
      commodity: {
        value: "",
        flag: 1,
      },
      variety: {
        value: "",
        flag: 1,
      },
      grower: {
        value: "",
        flag: 1,
      },
      package_type: {
        value: "",
        flag: 1,
      },
      Quantity: {
        value: "",
        flag: 1,
      },
      lot_num: {
        value: [],
      },
    },
    otherDefects: {
      othDefects: {},
      selected: {},
    },
    internalDefects: {
      intDefects: {},
      selected: {},
    },
    externalDefects: {
      extDefects: {},
      selected: {},
    },
    basicInfo: {
      sample_weight: 20,
      firmness: "",
      cleanness: "",
      shape: "",
      maturity: "",
      skinning: "",
      pulp_temperature: "",
    },
    samplesData: [],
    sampleStateData: [], // stores data for each smple in a seperate array
    sampleThresholds: [],
    samplesSizeData: [],
    reports: {},
    summary: [],
    InspSummFirstDate: "",
    InspSummLastDate: "",
    documents: [],
    varieties: [],
    inspectionTypes: [],
    inspector: [],
    documentsInView: [],
    files: {},
    imageTags: [],
    imageEditUrl: [],
    consignmentNums: [],
    purchase_orders: [],
    visible_purchase_orders: [],
    growers: [],
    inspectors: [],
    path: {
      view: "",
      categories: [],
    },

    // VisualAnalysis
    VisualAnalysis: {
      reports: [],
      report: {},
      commodities: [],
    },
  },

  /* state mutations starts here */
  mutations: {
    //login mutations
    //Added by Chandan
    // saves sample data
    updateSavedTab(state, data) {
      state.savedTabs = Math.max(state.savedTabs, data + 1);
    },
    saveSampleData(state, data) {
      var x = _.cloneDeep(data.sample);
      state.sampleStateData.splice(data.tab, 1, x);
    },
    // clears sample data on creating a new report
    resetSamples(state, data) {
      state.sampleStateData = [];
      for (var i = 0; i < data; i++) {
        state.sampleStateData.push({
          basicRequirements: {
            firmness: "",
            cleanness: "",
            shape: "",
            maturity: "",
            skinning: "",
            pulp_temperature: "",
            sample_weight: 20,
          },
          activeDefects: {
            external: [],
            internal: [],
            other: [],
          },
          sizeDesigType1: {
            type1Range: "",
            minWeight: 0,
            maxWeight: 0,
            overSize: 0,
            underSize: 0,
            status: true,
          },
          sizeDesigType2: [],
          images: [],
          tags: [],
        });
      }
    },
    setUpdateMode(state, flag) {
      //@P: change the update mode of report
      state.editSample = flag;
    },
    // saves images salone to samplestatedata
    uploadImages(state, data) {
      state.sampleStateData[data.tab].images = _.cloneDeep(data.images);

      // state.sampleStateData[data.tab].images.map((image, index) => image.file=data.images[index].file);
      state.sampleStateData[data.tab].images[0];
    },
    // loads all the info sent by backend to sample states
    loadInfo(state, data) {
      var sample_no = Object.keys(data.sampleDetails).length;
      for (var i = 0; i < sample_no; i++) {
        var sample = {
          activeDefects: {},
          basicRequirements: {},
        };
        for (var key in data.sampleDetails["sample_" + (i + 1)]) {
          if (data.sampleDetails["sample_" + (i + 1)].hasOwnProperty(key)) {
            if (["external", "internal", "other"].includes(key)) {
              sample.activeDefects[key] =
                data.sampleDetails["sample_" + (i + 1)][key];
            } else if (
              [
                "firmness",
                "cleanness",
                "shape",
                "maturity",
                "skinning",
                "pulp_temperature",
                "sample_weight",
              ].includes(key)
            ) {
              sample.basicRequirements[key] =
                data.sampleDetails["sample_" + (i + 1)][key];
            }
          }
        }
        sample.sizeDesigType1 =
          data.sizedesignation.type_1["sample_" + (i + 1)];
        sample.sizeDesigType2 =
          data.sizedesignation.type_2["sample_" + (i + 1)];
        if (!sample.sizeDesigType2) {
          sample.sizeDesigType1 = [];
        }
        if (!sample.sizeDesigType1) {
          sample.sizeDesigType1 = {
            type1Range: "",
            minWeight: 0,
            maxWeight: 0,
            overSize: 0,
            underSize: 0,
            status: true,
          };
        }
        state.sampleStateData[i] = sample;
        state.sampleStateData[i].tags = state.sampleStateData[i].tags
          ? state.sampleStateData[i].tags
          : [];
        state.sampleStateData[i].images = state.sampleStateData[i].images
          ? state.sampleStateData[i].images
          : [];
      }
    },
    // sets the path shown  above the content
    changePathLabel(state, data) {
      state.path.view = data.view;
      state.path.categories = data.categories;
    },
    //Chandan
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, data) {
      state.status = "success";
      state.token = data.token;
      state.user = data.user;
      state.username = data.username;
      state.cmdgroup = data.cmdgroup;
      state.firstName = data.first_name;
      state.lastName = data.last_name;
    },
    auth_error(state, msg) {
      state.status = "error";
    },
    loginError(state, data) {
      state.loginError = data;
      // console.log(state.loginError);
    },
    logout(state) {
      state.status = "";
      state.token = "";
    },
    getACLGroup(state, data) {
      state.aclGroups = _.cloneDeep(data.data);
    },
    show_modal(state, data) {
      state.modalVisible = data;
    },
    hideModal(state) {
      state.modalVisible = false;
    },
    removeToken(state) {
      state.token = "";
    },

    //admin get users for edit
    getUsers(state, data) {
      state.availableUsers = data;
    },
    getUser(state, data) {
      state.activeUser = data.user;
    },
    // reset states
    resetSavedTabs(state) {
      state.savedTabs = 0;
    },
    selectCommodity(state, data) {
      state.selectedCommodity = data;
    },
    // middle element changes to show template, sample, summary etc

    showTemplate(state) {
      state.template = true;
      state.sampleInfo = false;
    },
    showReport(state) {
      state.report = true;
      state.template = false;
      state.sampleInfo = false;
    },
    showSamples(state) {
      state.template = false;
      state.sampleInfo = true;
    },
    navigationChange(state) {
      state.template = false;
      state.sampleInfo = false;
      state.report = false;
    },
    //Save and delete image tags
    saveTags(state, data) {
      while (state.imageTags.length <= state.activeTab) {
        state.imageTags.push(new Array());
      }
      if (state.imageTags[state.activeTab].length <= data.imageid) {
        state.imageTags[state.activeTab].push(new Array());
      }
      state.imageTags[state.activeTab][data.imageid].push(data.tag);
    },
    deleteTags(state, data) {
      var deleteindex = state.imageTags[state.activeTab][data.imageid].indexOf(
        data.tag
      );
      state.imageTags[state.activeTab][data.imageid].splice(deleteindex, 1);
    },
    //image tags end

    //get general info in form temp component
    updateGeneralInfo(state, data) {
      state.num_samples = data.num_samples;
    },
    SortInspectionSummary(state, data) {
      state.documentsInView.sort((a, b) => {
        let modifier = 1;
        if (data.sortby === "asc") modifier = -1;
        if (a.inspection_time < b.inspection_time) return -1 * modifier;
        if (a.inspection_time > b.inspection_time) return 1 * modifier;
        return (state.documentsInView == state.documentsInView);
      });
    },
    updateDocId(state, id) {
      state.docId = id;

      for (var i = 0; i < state.documents.length; i++) {
        if (state.documents[i]._id == id) {
          return (state.num_samples = state.documents[i].num_samples);
        }
      }
    },
    getConsignmentNum(state, data) {
      state.consignmentNums = JSON.parse(JSON.stringify(data));
      state.generalInfo.vendor_no = {
        flag: 1,
        values: "",
      };
      state.generalInfo.lot_num = {
        flag: 1,
        value: [],
      };
    },

    getLotNum(state, data) {
      state.generalInfo = {
        ...state.generalInfo,
        lot_num: {
          value: data,
        },
      };
    },
    getLotNumPackline(state, data) {
      state.generalInfo = {
        ...state.generalInfo,
        lot_num: {
          value: data,
        },
      };
    },
    getConsignmentData(state, data) {
      state.generalInfo = {
        ...state.generalInfo,
        ...data.data,
      };
    },
    getPONoFromConsignment(state, data) {
      state.visible_purchase_orders = [data.purchase_order.value];
    },
    getConsignmentnosFromItemNo(state, data) {
      var data = JSON.parse(JSON.stringify(data));

      state.consignmentNums = data.consignmentNumbers;
    },
    getConsignmentandItemNoData(state, data) {
      var data = JSON.parse(JSON.stringify(data));
      // console.log("here");
      state.generalInfo = {
        ...state.generalInfo,
        ...data,
      };
    },
    getItemNumberData(state, data) {
      var data = JSON.parse(JSON.stringify(data));
      state.generalInfo.item_description = data.item_description
        ? data.item_description
        : "";
      state.generalInfo.commodity = data.commodity ? data.commodity : "";
      state.generalInfo.variety = data.variety ? data.variety : "";
      state.generalInfo.package_type = data.package_type
        ? data.package_type
        : "";
      state.generalInfo.vendor_no = data.vendor_no;
    },
    //set sample nums after submit general info
    samplesNum(state, num) {
      state.num_samples = num;
    },

    //Samples info changes for size designation and defects
    getOtherDefects(state, data) {
      state.sampleStateData[data.tab - 1].activeDefects.other =
        data.data.data.selected;
      state.otherDefects.othDefects = JSON.parse(
        JSON.stringify(data.data.data.othDefects)
      );
      state.otherDefects.selected = JSON.parse(
        JSON.stringify(data.data.data.selected)
      );
      state.otherDefects.threshold = JSON.parse(
        JSON.stringify(data.data.data.threshold)
      );
      state.otherDefects.totStatus = [];
      if (data.data.totStatus)
        state.otherDefects.totStatus = JSON.parse(
          JSON.stringify(data.data.data.totStatus)
        );
    },
    getExternalDefects(state, data) {
      // console.log(data);
      state.sampleStateData[data.tab - 1].activeDefects.external =
        data.data.data.selected;
      state.externalDefects.extDefects = JSON.parse(
        JSON.stringify(data.data.data.extDefects)
      );
      // state.externalDefects.selected = JSON.parse(JSON.stringify(data.data.selected));
      state.externalDefects.threshold = JSON.parse(
        JSON.stringify(data.data.data.threshold)
      );
      state.otherDefects.totStatus = [];
      if (data.data.data.totStatus)
        state.externalDefects.totStatus = JSON.parse(
          JSON.stringify(data.data.data.totStatus)
        );
    },
    getInternalDefects(state, data) {
      state.sampleStateData[data.tab - 1].activeDefects.internal =
        data.data.data.selected;
      state.internalDefects.intDefects = JSON.parse(
        JSON.stringify(data.data.data.intDefects)
      );
      state.internalDefects.selected = JSON.parse(
        JSON.stringify(data.data.data.selected)
      );
      state.internalDefects.threshold = JSON.parse(
        JSON.stringify(data.data.data.threshold)
      );
      state.otherDefects.totStatus = [];
      if (data.data.totStatus)
        state.internalDefects.totStatus = JSON.parse(
          JSON.stringify(data.data.data.totStatus)
        );
    },
    updateExternalDef(state, data) {
      var sel = JSON.parse(JSON.stringify(data));
      state.externalDefects.selected.push(sel);
      state.externalDefects.selected = _.uniq(
        state.externalDefects.selected,
        function(uqitems) {
          return uqitems.key;
        }
      );
    },

    updateInternalDef(state, data) {
      var sel = JSON.parse(JSON.stringify(data));
      state.internalDefects.selected.push(sel);
      state.internalDefects.selected = _.uniq(
        state.internalDefects.selected,
        function(uqitems) {
          return uqitems.key;
        }
      );
    },
    updateOtherDef(state, data) {
      var sel = JSON.parse(JSON.stringify(data));
      state.otherDefects.selected.push(sel);
      state.otherDefects.selected = _.uniq(
        state.otherDefects.selected,
        function(uqitems) {
          return uqitems.key;
        }
      );
    },
    deleteExternalDef(state, item) {
      state.externalDefects.selected = _.filter(
        state.externalDefects.selected,
        function(iteritems) {
          return iteritems.label !== item.label;
        }
      );
    },
    deleteInternalDef(state, item) {
      state.internalDefects.selected = _.filter(
        state.internalDefects.selected,
        function(iteritems) {
          return iteritems.label !== item.label;
        }
      );
    },
    deleteOtherDef(state, item) {
      state.otherDefects.selected = _.filter(
        state.otherDefects.selected,
        function(iteritems) {
          return iteritems.label !== item.label;
        }
      );
    },
    setActiveTab(state, data) {
      state.activeTab = data;
    },

    //basic save for basic requirements in samples
    basicSave(state, item) {
      state.basicInfo.firmness = item.firmness;
      state.basicInfo.cleanness = item.cleanness;
      state.basicInfo.sample_weight = item.sample_weight
        ? item.sample_weight
        : 20;
      state.basicInfo.maturity = item.maturity;
      state.basicInfo.shape = item.shape;
      state.basicInfo.skinning = item.skinning;
      state.basicInfo.pulp_temperature = item.pulp_temperature;
    },
    updateBasicInfo(state, item) {
      state.basicInfo[item.id] = item.value;
    },

    //images mutations for samples and reports

    imageUpload(state, resp) {
      let data = JSON.parse(JSON.stringify(resp));
      state.files[state.activeTab] = data.files;
      state.imageEditUrl = data.urls;
      //state.imageEditUrl = data.urls;

      // console.log(state.imageEditUrl);
    },
    getImages(state, data) {
      let images = {};
      for (let i in data) {
        let x = data[i];
        images[i] = [];
        for (let item of x) {
          let tags = item.tags;
          delete item.tags;
          let url = item[Object.keys(item)[0]];
          images[i].push({
            tags,
            url,
          });
        }
      }
      // state.imageEditUrl = data[state.activeTab];
      state.reportUrl = images;
    },

    fileUpload(state, { urls, tab }) {
      for (var item in urls) {
        // alert("1")
        let key = item;
        let url = urls[key];
        state.sampleStateData[tab - 1].images.push({
          key,
          url,
        });
        state.sampleStateData[tab - 1].tags.push([]);
      }
    },
    getSampleImages(state, { urls, tab }) {
      return new Promise((res, rej) => {
        state.sampleStateData[tab - 1].images = [];
        let tags = [],
          images = [];
        for (var i = 0; i < urls.length; i++) {
          let item = urls[i];
          tags.push(_.cloneDeep(item.tags));
          delete item.tags;
          let key = Object.keys(item)[0];
          let url = item[key];
          state.sampleStateData[tab - 1].images.push({
            key,
            url,
          });
        }
        state.sampleStateData[tab - 1]["tags"] = tags;
        res();
      });
    },

    deleteSampleImage(state, { index, sampleIndex }) {
      state.sampleStateData[sampleIndex].images.splice(index, 1);
      state.sampleStateData[sampleIndex].tags.splice(index, 1);
    },

    // Potato Image End
    clearStateGeneralInfo(state) {
      state.generalInfo = {
        purchase_order: {
          value: "",
          flag: 1,
        },
        item_no: {
          value: "",
          flag: 1,
        },
        item_description: {
          value: "",
          flag: 1,
        },
        commodity: {
          value: "",
          flag: 1,
        },
        variety: {
          value: "",
          flag: 1,
        },
        grower: {
          value: "",
          flag: 1,
        },
        package_type: {
          value: "",
          flag: 1,
        },
        Quantity: {
          value: "",
          flag: 1,
        },
      };
    },

    //tab click and save and next click in samples
    tabClick(state, tab) {
      state.activeTab = tab;
    },
    nextClick(state, tab) {
      state.activeTab = tab;
      if (tab >= state.savedTabs + 2) state.savedTabs = state.savedTabs + 1;
    },

    resetState(state, nonEditFlag) {
      if (!nonEditFlag) {
        state.basicInfo = {
          sample_weight: 20,
          firmness: "",
          cleanness: "",
          shape: "",
          maturity: "",
          skinning: "",
          pulp_temperature: "",
        };
      } else {
        state.activeTab = 1;
        // state.imageEditUrl = [];
      }
    },

    // on edit call get defects selected in samples
    updateExtSelected(state, data) {
      state.externalDefects.selected = JSON.parse(JSON.stringify(data.data));
      state.externalDefects.totStatus = JSON.parse(
        JSON.stringify(data.totStatus)
      );
    },
    updateIntSelected(state, data) {
      state.internalDefects.selected = JSON.parse(JSON.stringify(data.data));
      state.internalDefects.totStatus = JSON.parse(
        JSON.stringify(data.totStatus)
      );
    },
    updateOthSelected(state, data) {
      state.otherDefects.selected = JSON.parse(JSON.stringify(data.data));
      state.otherDefects.totStatus = JSON.parse(JSON.stringify(data.totStatus));
    },

    // snack bar to show error response
    showSnackbar(state, data) {
      (state.snackbar = true), (state.snackbarMsg = data.msg);
      setTimeout(() => (state.snackbar = false), 5000);
    },
    hideSnackBar(state) {
      state.snackbar = false;
    },
    // Loader
    showLoader(state, data) {
      state.loading = data;
    },
    //Get reports call
    getReports(state, data) {
      var resp = JSON.parse(JSON.stringify(data));
      state.reports = resp;
      // console.log(state.reports);

      // if(!state.report.basicinfo.approveStatus){
      //   state.report.basicinfo.approveStatus=false
      // }
      if (!state.reports.basicinfo.userComments) {
        state.reports.basicinfo.userComments = {
          flag: false,
          values: [],
        };
      }
      if (!state.reports.basicinfo.approveStatus) {
        state.reports.basicinfo.approveStatus = false;
        state.reports.basicinfo.approveManager = "";
      }
    },
    updateSampleData(state, data) {
      var resp = JSON.parse(JSON.stringify(data.sampleDetails));
      var keys = Object.keys(resp);

      state.samplesData = [];
      for (var key in keys) {
        state.samplesData.push(resp[keys[key]]);
      }
    },
    updateSampleSizeData(state, data) {
      var resp = JSON.parse(JSON.stringify(data.sizedesignation));
      var keys = Object.keys(resp.type_1);
      state.samplesSizeData = [];
      for (var key in keys) {
        state.samplesSizeData.push({
          type_1: resp.type_1[keys[key]],
          type_2: resp.type_2[keys[key]],
        });
      }
    },
    UpdateComments(state, data) {
      state.reports.basicinfo.userComments.flag = true;
      if (state.reports.basicinfo.userComments.values.length == 0) {
        state.reports.basicinfo.userComments.values = [data];
      } else {
        state.reports.basicinfo.userComments.values = [
          data,
          ...state.reports.basicinfo.userComments.values,
        ];
      }
    },

    ApproveReport(state) {
      // console.log(state.reports.basicinfo);
      state.reports.basicinfo.approveStatus = true;
      state.reports.basicinfo.approveManager = state.username;
    },

    //get documents call
    getDocuments(state, data) {
      state.documentsInView = JSON.parse(JSON.stringify(data.docIds_List));
      // state.summary = JSON.parse(JSON.stringify(data.docIds_List));
      state.documents = JSON.parse(JSON.stringify(data.docIds_List));
      state.varieties = {};
      state.consignmentNums = data.dropdown.consignment_num;
      state.purchase_orders = data.dropdown.purchase_order;
      state.growers = data.dropdown.grower;
      state.inspectionTypes = data.dropdown.inspection_type;
      state.inspectors = data.dropdown.users;
      // data.dropdown.commodity.forEach(comm => {
      // console.log(state.varieties);

      state.varieties = data.dropdown.variety;
      state.commodities = data.dropdown.commodity;
      // });

      state.inspection_type = data.inspection_type;
      //state.InspSummFirstDate = state.documents[0].inspection_date

      //state.InspSummLastDate = state.documents[0].inspection_date

      //state.documentsInView = JSON.parse(JSON.stringify(state.documents))
      // commit("applyFilter",{sDate:new Date(),lDate:new Date()})
    },
    getDocumentsbyStatus(state, data) {
      state.documentsInView = state.documentsInView.filter(
        (obj) => obj.weighted_status == data
      );
    },

    showNonEditableSamples(state, flag) {
      state.nonEditflag = flag;
    },
    //inspection summary filet apply

    applyFilter(state, documents) {
      state.documentsInView = JSON.parse(JSON.stringify(documents));
    },

    // Inspection Summary Date Filter
    async applyDateFilter(state, Date) {
      state.documentsInView = await Misc.FilterInspSummByDate(
        state.documentsInView,
        Date.sDate,
        Date.lDate
      );
      // console.log(state.documentsInView);
    },
    // Commodity Groups Starts
    getCGroups(state, data) {
      state.commGroups = _.clone(data);
    },
    setCGroupId(state, id) {
      state.editGroupId = id;
    },
    getcommodities(state, data) {
      state.Commodities = data;
    },
    getCGroup(state, data) {
      // console.log(data);
      state.activeGroup = data.cmdGroup;
      state.activeGroup.users = data.users;
    },
    // General Info
    ...GeneralInfoStore.mutations,
    // General Info End
    //Onion Commodity
    ...OnionStore.mutations,
    // Onion COmmodity End
    //Potato Commodity
    ...PotatoStore.mutations,
    // Potato COmmodity End

    //Autonomous Inspection
    ...VisualAnalysisStore.mutations,
    // Autonomous Inspection End
  },
  /* state mutations ends here */

  /* actions apis calls starts here */
  actions: {
    //actions by chandan
    //chandan
    //login function
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios({
          url: baseUrl + "/api/account/login",
          data: user,
          method: "POST",
        })
          .then((resp) => {
            if (resp.data.error) {
              // console.log("here");
              commit("loginError", true);
              commit("showLoader", false);
              return reject(resp.data.msg);
            } else {
              const token = resp.data.token;
              var user = "admin";
              var username = "AD";
              commit("loginError", false);
              if (resp.data.role) {
                user = resp.data.role.toLowerCase();
                username = resp.data.username;

                // cmdgroup = resp.data
              }
              localStorage.setItem("token", token);
              // Add the following line:
              axios.defaults.headers.common["Authorization"] = token;
              commit("auth_success", {
                ...resp.data,
                token: token,
                user: user,
                username: username,
                cmdgroup: resp.data.cmdgroup,
              });
              resolve(resp);
            }
          })
          .catch((err) => {
            commit("auth_error");
            commit("loginError", true);

            commit("showSnackbar", {
              msg: "Network Issue!",
            });
            commit("showLoader", false);
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    validateEmail({ commit }, email) {
      console.log("payload", email);
      return new Promise((resolve, reject) => {
        axios({
          url: baseUrl + "/api/account/login/forget-password",
          data: email,
          method: "POST",
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            console.log(err);
            reject(err)
          });
      })
    },
    validateCode({commit}, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: baseUrl + "/api/account/login/verify-otp",
          data: data,
          method: "POST",
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            console.log(err);
            reject(err)
          });
      })
    },
    resetPassword({commit}, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: baseUrl + "/api/account/login/update-password",
          data: data,
          method: "POST",
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            console.log(err);
            reject(err)
          });
      })
    },
    showModal({ commit }, token) {
      commit("show_modal", token);
    },
    hideModal({ commit }) {
      commit("show_modal", false);
    },
    addUser({ state, commit }, user) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        // console.log("posted");

        commit("auth_request");
        Axios.post(baseUrl + "/api/account/user", user, config)
          .then((resp) => {
            // console.log(resp.data);

            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              reject(resp.data.msg);
            } else {
              commit("showSnackbar", {
                msg: "User added successfully",
              });
              commit("showLoader", false);
              return resolve(resp.data.userId);
            }
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error", err);

            commit("showSnackbar", {
              msg: "Network Issue!",
            });
            commit("showLoader", false);
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    getACLGroup({ state, commit }) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.get(baseUrl + "/api/account/aclgroups", config)
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              reject(resp.data.msg);
              // return router.push('/app/login')
            } else {
              commit("getACLGroup", resp.data);
              resolve(resp);
            }
          })
          .catch((err) => {
            commit("auth_error", err);

            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);
            reject(err);
          });
      });
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        commit("logout");
        localStorage.removeItem("token");
        delete axios.defaults.headers.common["Authorization"];
        resolve();
      });
    },
    selectCommodity({ commit }, data) {
      commit("selectCommodity", data);
    },

    //inspection template calls starts
    showTemplate({ commit }) {
      commit("showTemplate");
    },
    showReport({ commit }) {
      commit("showReport");
    },
    showSamples({ commit }) {
      commit("showSamples");
    },
    samplesNum({ commit }) {
      commit("samplesNum");
    },
    getConsignmentNum({ commit, state }, commodity) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.get(baseUrl + "/api/reports/consignment/" + commodity, config)
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              return router.push("/app/login");
            } else {
              commit("getConsignmentNum", resp.data.consignmentNumbers);

              resolve(resp);
            }
          })
          .catch((err) => {
            commit("auth_error", err);

            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);
            reject(err);
          });
      });
    },

    getLotNum({ commit, state }, { commodity, consignment_num }) {
      commit("showLoader", true);
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        let url = `${baseUrl}/api/reports/lotNoFetch/${commodity}`;
        if (consignment_num) {
          url += `/${consignment_num}`;
        }
        Axios.get(url, config)
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              return router.push("/app/login");
            } else {
              commit("getLotNum", resp.data.lot_number);

              resolve(resp);
            }
          })
          .catch((err) => {
            commit("auth_error", err);

            commit("showSnackbar", {
              msg: err,
            });
            reject(err);
          })
          .finally(function() {
            commit("showLoader", false);
            // settled (fulfilled or rejected)
          });
      });
    },
    getLotNumPackline({ commit, state }, { commodity, consignment_num }) {
      commit("showLoader", true);
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        let url = `${baseUrl}/api/reports/packline/lotNoFetch/potato`;
        if (consignment_num) {
          url += `/${consignment_num}`;
        }
        Axios.get(url, config)
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              return router.push("/app/login");
            } else {
              commit("getLotNumPackline", resp.data.lot_number);

              resolve(resp);
            }
          })
          .catch((err) => {
            commit("auth_error", err);

            commit("showSnackbar", {
              msg: err,
            });
            reject(err);
          })
          .finally(function() {
            commit("showLoader", false);
            // settled (fulfilled or rejected)
          });
      });
    },
    getConsignmentData({ commit, state }, { commodity, consignment_num }) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.get(
          baseUrl +
            "/api/reports/itemNoFetch/" +
            consignment_num +
            "/" +
            commodity,
          config
        )
          .then(async (resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
            } else {
              await commit("getConsignmentData", resp.data);

              resolve(resp);
            }
          })
          .catch((err) => {
            commit("auth_error", err);

            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);
            reject(err);
          });
      });
    },
    getPONoFromConsignment({ commit, state }, num) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        commit("showLoader", true);
        Axios.get(baseUrl + "/api/reports/itemNoFetch/" + num, config)
          .then((resp) => {
            commit("showLoader", false);
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
            } else {
              commit("getPONoFromConsignment", resp.data.data);

              resolve(resp);
            }
          })
          .catch((err) => {
            commit("auth_error", err);

            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);
            reject(err);
          });
      });
    },
    getConsignmentnosFromItemNo({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.get(
          baseUrl +
            "/api/reports/consignment/" +
            data.item_no +
            "/" +
            data.commodity,
          config
        )
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
            } else {
              commit("getConsignmentnosFromItemNo", resp.data);

              resolve(resp);
            }
          })
          .catch((err) => {
            commit("auth_error", err);

            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);
            reject(err);
          });
      });
    },
    getItemfromLot({ commit, state }, lot_num) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.get(
          baseUrl + "/api/reports/itemNo_autopopulate/lot/" + lot_num,
          config
        )
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
            } else {
              commit("getConsignmentandItemNoData", resp.data.data);

              resolve(resp);
            }
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);
            reject(err);
          });
      });
    },
    getItemfromLotPackline({ commit, state }, lot_num) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.get(
          baseUrl + "/api/reports/packline/itemNo_autopopulate/lot/" + lot_num,
          config
        )
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
            } else {
              commit("getConsignmentandItemNoData", resp.data.data);

              resolve(resp);
            }
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);
            reject(err);
          });
      });
    },
    getConsignmentandItemNoData({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.get(
          baseUrl +
            "/api/reports/itemNo_autopopulate/consignment/" +
            data.consignment_num +
            "/" +
            data.item_no +
            "/" +
            data.commodity,
          config
        )
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
            } else {
              commit("getConsignmentandItemNoData", resp.data.data);

              resolve(resp);
            }
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            reject(err);
          })
          .finally(() => {
            commit("showLoader", false);
          });
      });
    },
    getItemNumberData({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.get(
          baseUrl +
            "/api/reports/itemNo_autopopulate/" +
            data.item_no +
            "/" +
            state.selectedCommodity,
          config
        )
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: "" + resp.data.msg,
              });
              commit("showLoader", false);
              reject();
            } else {
              commit("getItemNumberData", resp.data.data);

              resolve(resp);
            }
          })
          .catch((err) => {
            reject(err);
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);
          });
      });
    },
    updateGeneralInfo({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.post(baseUrl + "/api/reports/inspection", data, config)
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
            } else {
              commit("updateGeneralInfo", data);
              // commit('showSamples');
              commit("updateDocId", resp.data.docid);
              commit("resetSavedTabs");
              // commit('tabClick', 1);
              resolve(resp);
            }
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);
            reject(err);
          });
      });
    },
    editGeneralInfo({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.put(
          baseUrl + "/api/reports/inspection/" + state.docId,
          data,
          config
        )
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
            } else {
              commit("updateGeneralInfo", data);
              if (state.user == "manager" || !state.nonEditFlag) {
                // commit('showSamples');
                commit("resetSavedTabs");
                commit("tabClick", 1);
                resolve(resp);
              } else {
                commit("showReport");
              }
            }
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);
            reject(err);
          });
      });
    },
    confirmPotatoReport({ commit, state }, docId) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.get(
          baseUrl + "/api/reports/inspection/" + state.docId + "/confirm",
          config
        )
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
            } else {
              resolve(resp);
            }
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);
            reject(err);
          });
      });
    },
    updateDocId({ commit }, id) {
      commit("updateDocId", id);
    },

    navigationChange({ commit }) {
      commit("navigationChange");
    },

    //samples functons starts
    getSizeDesignation({ commit, state }, tab) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        var url =
          baseUrl +
          "/api/reports/inspection/" +
          state.docId +
          "/sizedesig/" +
          tab;
        Axios.get(url, config)
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              reject(resp.data.msg);
            }
            commit("getSizeDesig", resp.data);

            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error", err);

            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);
            reject(err);
          });
      });
    },
    getExternalDefects({ commit, state }, tab) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        var url =
          baseUrl +
          "/api/reports/inspection/" +
          state.docId +
          "/defect/external/" +
          tab;
        Axios.get(url, config)
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              reject(resp.data.msg);
            }
            commit("getExternalDefects", {
              data: resp.data,
              tab: tab,
            });

            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);
            reject(err);
          });
      });
    },
    getInternalDefects({ commit, state }, tab) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        var url =
          baseUrl +
          "/api/reports/inspection/" +
          state.docId +
          "/defect/internal/" +
          tab;
        Axios.get(url, config)
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              return reject(resp.data.msg);
            }
            commit("getInternalDefects", {
              data: resp.data,
              tab: tab,
            });
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);
            reject(err);
          });
      });
    },
    getOtherDefects({ commit, state }, tab) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        var url =
          baseUrl +
          "/api/reports/inspection/" +
          state.docId +
          "/defect/other/" +
          tab;
        Axios.get(url, config)
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              return;
            }
            commit("getOtherDefects", {
              data: resp.data,
              tab: tab,
            });
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);
            reject(err);
          });
      });
    },
    saveExternalDef({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        var data = JSON.stringify(params.defects);
        var url =
          baseUrl +
          "/api/reports/inspection/" +
          state.docId +
          "/defect/external/" +
          params.tab;
        Axios.put(url, data, config)
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              return reject(resp.data.msg);
            }
            commit("updateExtSelected", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    saveInternalDef({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        var data = JSON.stringify(params.defects);
        var url =
          baseUrl +
          "/api/reports/inspection/" +
          state.docId +
          "/defect/internal/" +
          params.tab;
        Axios.put(url, data, config)
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              return reject(resp.data.msg);
            }
            commit("updateIntSelected", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    saveOtherDef({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        var data = params.defects;
        if (data.length == 1 && data[0].type == "No Defect Present") data = [];

        var url =
          baseUrl +
          "/api/reports/inspection/" +
          state.docId +
          "/defect/other/" +
          params.tab;
        Axios.put(url, JSON.stringify(data), config)
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              return reject(resp.data.msg);
            }
            commit("updateOthSelected", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    removeSizeDesigType2({ commit }, data) {
      commit("removeSizeDesigType2", data);
    },

    updateBasicSave({ commit }, data) {
      commit("updateBasicInfo", data);
    },
    updateExternalDef({ commit }, data) {
      commit("updateExternalDef", data);
    },

    updateInternalDef({ commit }, data) {
      commit("updateInternalDef", data);
    },
    updateOtherDef({ commit }, data) {
      commit("updateOtherDef", data);
    },
    deleteOtherDef({ commit }, data) {
      commit("deleteOtherDef", data);
    },
    deleteExternalDef({ commit }, data) {
      commit("deleteExternalDef", data);
    },
    deleteInternalDef({ commit }, data) {
      commit("deleteInternalDef", data);
    },
    basicSave({ commit, state }, data, activeTab) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        var url =
          baseUrl +
          "/api/reports/inspection/" +
          state.docId +
          "/sample/" +
          data.sampleno;
        Axios.post(url, JSON.stringify(data.basicRequirements), config)
          .then((resp) => {
            // if(resp.data.error){
            //   return commit('showSnackbar', {msg : resp.data.msg})
            // }
            commit("basicSave", data);
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    tabClick({ commit }, tab) {
      commit("tabClick", tab);
    },
    nextClick({ commit }, tab) {
      commit("nextClick", tab);
    },
    savePage({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        var url =
          baseUrl +
          "/api/reports/inspection/" +
          state.docId +
          "/sizedesig/" +
          data.tab;
        Axios.put(url, data.typesdata, config)
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              return reject(resp.data.msg);
            }
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);
            reject(err);
          });
      });
    },

    //snack bar functions
    showSnackbar({ commit }, data) {
      commit("showSnackbar", data);
    },
    hideSnackBar({ commit }) {
      commit("hideSnackBar");
    },
    //LOADER
    showLoader({ commit }, data) {
      commit("showLoader", data);
    },

    // Inspection Summary

    SortInspectionSummary({ state, commit }, data) {
      commit("SortInspectionSummary", data);
    },

    //reports functions
    getReportsData({ commit, dispatch, state }, reportId) {
      state.docId = reportId;
      state.reports = {};
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        var url = baseUrl + "/api/reports/inspection/" + reportId + "/report";
        Axios.get(url, config)
          .then(async (resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              return reject();
            }
            await commit("getReports", resp.data.data),
              await dispatch("loadInfo", resp.data.data),
              await commit("updateGeneralInfo", resp.data.data.basicinfo);
            await commit("updateSampleData", resp.data.data);
            await commit("updateSampleSizeData", resp.data.data);
            resolve();
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);

            reject(err);
          });
      });
    },
    deleteReport({ commit, dispatch, state }, reportId) {
      state.docId = reportId;
      state.reports = {};
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        var url = baseUrl + "/api/reports/delete/" + reportId;
        Axios.delete(url, config)
          .then(async (resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              return reject();
            }
            resolve();
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);

            reject(err);
          });
      });
    },
    async loadInfo({ commit, dispatch, state }, data) {
      await commit("loadInfo", data);
      for (
        var sampleno = 0;
        sampleno < Object.keys(data.sampleDetails).length;
        sampleno++
      ) {
        await dispatch("getExternalDefects", sampleno + 1);
        await dispatch("getInternalDefects", sampleno + 1);
        await dispatch("getOtherDefects", sampleno + 1);
      }
    },
    // Inspector Comments
    EditInspectorComments({ commit, state }, comments) {
      state.reports.basicinfo.comments = comments;
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.put(
          baseUrl + "/api/reports/inspection/" + state.docId,
          state.reports.basicinfo,
          config
        )
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              return reject();
            }
          })
          .catch((err) => {
            commit("auth_error", err);
            reject(err);
          });
      });
    },
    AddComment({ commit, state }, comment) {
      // state.reports.basicinfo.userComments.flag=true;
      // state.reports.basicinfo.userComments.push(comment);
      commit("UpdateComments", comment);
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.put(
          baseUrl + "/api/reports/inspection/" + state.docId,
          state.reports.basicinfo,
          config
        )
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              return reject();
            } else {
            }
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);

            reject(err);
          });
      });
    },

    //inspection summary calls
    getDocuments({ commit, state }, filters) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        var url = baseUrl + "/api/reports/inspectionSummary";
        Axios.post(url, filters, config)
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              return reject();
            }
            commit("getDocuments", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);

            reject(err);
          });
      });
    },
    getDocumentsbyStatus({ commit, state }, alert) {
      commit("getDocumentsbyStatus", alert);
    },
    // Approve the Report
    ApproveReport({ commit, state }) {
      commit("ApproveReport");
    },
    clearStateGeneralInfo({ commit }) {
      commit("clearStateGeneralInfo");
    },
    resetState({ commit }, flag) {
      commit("resetState", flag);
    },
    updateType1Size({ commit }, data) {
      commit("updateType1Size", data);
    },
    showNonEditableSamples({ commit }, flag) {
      commit("showNonEditableSamples", flag);
    },
    applyDateFilter({ commit }, Date) {
      commit("applyDateFilter", Date);
    },
    applyFilter({ commit }, documents) {
      commit("applyFilter", documents);
    },
    removeToken({ commit }) {
      commit("removeToken");
      localStorage.removeItem("token");
      delete axios.defaults.headers.common["Authorization"];
    },

    //image upload function for samples
    async fileUpload({ commit, state }, files) {
      let formData = new FormData();

      for (var i = 0; i < files.images.length; i++) {
        let file = files.images[i];
        // let tag = Object.assign({},files.images[i].tags);
        //file.tag = tagstring;
        //let file = new File(["gdeyfejurdwcbrjwkhrfuknrjwveu"], "testfile.png", { tag: tagstring});
        formData.append("files[" + i + "]", file.file);
      }
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
            "Content-Type": "multipart/form-data",
          },
        };
        var url =
          baseUrl +
          "/api/reports/images/" +
          files.docId +
          "/" +
          files.commodity +
          "/" +
          files.tab;
        // var url = baseUrl + '/api/reports/inspection/' + state.docId + '/' + files.commodity + '/images/' + files.tab
        Axios.post(url, formData, config)
          .then((resp) => {
            if (resp.data.error) {
              commit("showLoader", false);
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              return reject();
            }
            if (resp.data.msg == "Files Uploaded")
              commit("fileUpload", {
                urls: resp.data.urls,
                tab: files.tab,
              });
            resolve(resp);
          })
          .catch((err) => {
            commit("showSnackbar", {
              msg: "Image upload Failed. Try again Later!!!",
            });
            commit("showLoader", false);
            return reject();
          });
      });
    },
    getImages({ commit, state }, { docId, commodity }) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
            "Content-Type": "multipart/form-data",
          },
        };
        // console.log("in getImages", state.num_samples);

        var url = baseUrl + "/api/reports/images/" + docId + `/${commodity}`;
        Axios.get(url, config)
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              return reject();
            }
            commit("getImages", resp.data.urls);
            commit("showLoader", false);
            resolve();
          })
          .catch((err) => {
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);
            return reject();
          });
      });
    },
    getSampleImages({ commit, state }, { docId, tab, commodity }) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
            "Content-Type": "multipart/form-data",
          },
        };
        // console.log("in getImages", state.num_samples);

        var url =
          baseUrl +
          "/api/reports/images/" +
          docId +
          "/" +
          commodity +
          "/" +
          tab;
        // var url = baseUrl + '/api/reports/images/' + docId + '/' + commodity + '/' + tab
        Axios.get(url, config)
          .then(async (resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              return reject();
            }

            await commit("getSampleImages", {
              urls: resp.data.urls,
              tab,
            });
            resolve();
          })
          .catch((err) => {
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);
            return reject();
          });
      });
    },
    deleteSampleImage({ commit, state }, { key, index, sampleIndex }) {
      return new Promise((res, rej) => {
        commit("auth_request");
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.delete(baseUrl + "/api/reports/images/" + key, config)
          // Axios.delete(baseUrl + '/api/reports/images/' + key, config)
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              rej(resp.data.msg);
            } else {
              commit("deleteSampleImage", {
                index,
                sampleIndex,
              });
              // commit('showSnackbar', {
              //   msg: 'Deleted Succesfully'
              // })
              res(resp);
            }
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);

            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    saveImageTags({ commit, state }, tags) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.put(baseUrl + "/api/reports/images/tags", tags, config)
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              return reject();
            }
            resolve();
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);
            reject(err);
          });
      });
    },
    imageUpload({ commit }, data) {
      commit("imageUpload", data);
    },
    // File upload End
    // User Manaagement Start
    getUsers({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.get(baseUrl + "/api/account/user", config)
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              return reject();
            } else {
              commit("getUsers", resp.data.data.users);
            }
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);

            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    getUser({ commit, state }, id) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.get(baseUrl + "/api/account/user/" + id, config)
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              return reject();
            } else {
              commit("getUser", resp.data.data);
            }
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);

            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    updateUser({ commit, state }, content) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.put(
          baseUrl + "/api/account/user/" + content.id,
          content.user,
          config
        )
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              return reject();
            }
            resolve(resp.data.msg);
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);

            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    deleteUser({ commit, state }, content) {
      return new Promise((res, rej) => {
        commit("auth_request");
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.delete(baseUrl + "/api/account/user/" + content, config)
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              rej(resp.data.msg);
            } else {
              commit("showSnackbar", {
                msg: "Deleted Succesfully",
              });
              res(resp);
            }
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);

            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    // User Manaagement End
    // Commodity Group Management
    getCGroups({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.get(baseUrl + "/api/account/commoditygroups", config)
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              return reject(resp.data.msg);
            } else {
              commit("getCGroups", resp.data.data);
            }
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);

            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    getallCommodities({ state, commit }) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.get(baseUrl + "/api/account/allcommodities", config)
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              return reject(resp.data.msg);
            } else {
              commit("getcommodities", resp.data.Commodities);
            }
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);

            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    addCGroups({ state, commit }, user) {
      return new Promise((resolve, reject) => {
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        // console.log("posted");

        commit("auth_request");
        Axios.post(baseUrl + "/api/account/commoditygroups", user, config)
          .then((resp) => {
            // console.log(resp.data);

            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              reject(resp.data.msg);
            } else {
              commit("setCGroupId", resp.data.id);
              commit("showSnackbar", {
                msg: "Group added successfully",
              });
            }
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error", err);

            commit("showSnackbar", {
              msg: "Network Issue!",
            });
            commit("showLoader", false);
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    getCGroup({ commit, state }, id) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.get(baseUrl + "/api/account/commoditygroups/" + id, config)
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              return reject();
            } else {
              commit("getCGroup", resp.data.data);
            }
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);

            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    updateCGroup({ commit, state }, content) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.put(
          baseUrl + "/api/account/commoditygroups/" + state.editGroupId,
          content,
          config
        )
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              return reject();
            }
            commit("getCGroup", {
              cmdGroup: {},
              users: [],
            });
            commit("showSnackbar", {
              msg: resp.data.msg,
            });
            resolve(resp.data.msg);
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);

            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    deleteCGroup({ commit, state }, content) {
      return new Promise((res, rej) => {
        commit("auth_request");
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.delete(
          baseUrl + "/api/account/commoditygroups/" + content,
          config
        )
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              rej(resp.data.msg);
            } else {
              commit("showSnackbar", {
                msg: "Deleted Succesfully",
              });
              res(resp);
            }
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);

            localStorage.removeItem("token");
            rej(err);
          });
      });
    },
    removeUserFromCGroup({ commit, state }, ids) {
      return new Promise((res, rej) => {
        commit("auth_request");
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };
        Axios.delete(
          baseUrl + `/api/account/commoditygroups/${ids.cid}/${ids.uid}`,
          config
        )
          .then((resp) => {
            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              rej(resp.data.msg);
            } else {
              // commit('showSnackbar', {
              //   msg: 'Remove Succesfully'
              // })
              // dispatch('getCGroup',)
              res(resp);
            }
          })
          .catch((err) => {
            commit("auth_error", err);
            commit("showSnackbar", {
              msg: err,
            });
            commit("showLoader", false);

            localStorage.removeItem("token");
            rej(err);
          });
      });
    },
    // Commodity Group Management
    // Logs
    AddUserLog({ commit, state }, log) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        var config = {
          headers: {
            Authorization: "bearer " + state.token,
          },
        };

        Axios.post(baseUrl + "/api/account/logs", log, config)
          .then((resp) => {
            // console.log(resp.data);

            if (resp.data.error) {
              commit("showSnackbar", {
                msg: resp.data.msg,
              });
              commit("showLoader", false);
              return reject(resp.data.msg);
            } else {
              commit("showLoader", false);
            }
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error", err);

            commit("showSnackbar", {
              msg: "Network Issue!",
            });
            commit("showLoader", false);
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    //Logs End

    // General Info
    ...GeneralInfoStore.actions,
    // General Info End
    //OnionCommodity Materials
    ...OnionStore.actions,
    //OnionCommodity Materials End
    //PotatoCommodity Materials
    ...PotatoStore.actions,
    //PotatoCommodity Materials End

    //VisualAnalysis Materials
    ...VisualAnalysisStore.actions,
    //VisualAnalysis Materials End
  },
  getters: {
    isLoggedIn: (state) => !!state.token,
    authStatus: (state) => state.status,
    template: (state) => state.template,
    externalDefects: (state) => state.externalDefects,
    internalDefects: (state) => state.internalDefects,
    otherDefects: (state) => state.otherDefects,
  },
});

/* actions apis calls ends here */
